import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { InvitationB2BClientModule } from '@app/invitation/invitation-b2b/invitation-b2b-client/invitation-b2b-client.module';
import { InvitationB2BPartnerModule } from '@app/invitation/invitation-b2b/invitation-b2b-partner/invitation-b2b-partner.module';
import { InvitationPublicCloudCreatePasswordModule } from '@app/invitation/invitation-public-cloud-create-password/invitation-public-cloud-create-password.module';
import { SharedSignupModule } from '@app/shared-signup/shared-signup.module';
import { CartState } from '@app/store/state/cart.state';
import { SignupState } from '@app/store/state/signup.state';
import {
  AvatarModule,
  ButtonLoaderModule,
  EscapeHtmlModule,
  IkPasswordInputModule,
  InfoBoxModule,
  LoaderModule,
  PhoneInputModule,
  ValidationCheckModule,
} from '@infomaniak/angular-common';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxsModule } from '@ngxs/store';
import { TooltipModule } from '@infomaniak/ngx-tooltip-directive';
import { ClipboardModule } from 'ngx-clipboard';
import { SwiperModule } from 'ngx-swiper-wrapper';

import { SignupErrorsModule } from './errors/signup-errors.module';
import { SignupLandingFooterComponent } from './components/signup-landing-footer/signup-landing-footer.component';
import { SignupLanguageSwitcherModule } from './components/signup-language-switcher/signup-language-switcher.module';
import { SignupComponent } from './signup.component';
import { SignupService } from './shared/signup.service';
import { SignupLandingButtonsComponent } from './components/singup-landing-buttons/signup-landing-buttons.component';
import { WebmailPasswordComponent } from './components/webmail-password/webmail-password.component';
import { V2Component } from './new-layout/v2.component';
import { SignupConnectedComponent } from './new-layout/signup-connected/signup-connected.component';
import { SignupNotConnectedComponent } from './new-layout/signup-not-connected/signup-not-connected.component';
import { SignupRightBlockComponent } from './new-layout/signup-not-connected/signup-right-block/signup-right-block.component';
import { SignupLeftBlockComponent } from './new-layout/signup-not-connected/signup-left-block/signup-left-block.component';
import { SignupLeftBlockKsuiteComponent } from './new-layout/signup-not-connected/signup-left-block/ksuite/ksuite.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SignupDuplicatePersonnalDialogComponent } from './new-layout/signup-not-connected/dialogs/duplicate-personnal/duplicate-personnal.component';
import { SignupDuplicateOrganisationDialogComponent } from './new-layout/signup-not-connected/dialogs/duplicate-organisation/duplicate-organisation.component';
import { MatDialogModule } from '@angular/material/dialog';
import { KsuiteBlockInfoModule } from '@app/order/selection/ksuite/shared/info-block/ksuite-info-block.module';
import { SignupRightblockClassicComponent } from './new-layout/signup-not-connected/signup-right-block/signup-rightblock-classic/signup-rightblock-classic.component';

export const routes = [
  {
    path: '',
    pathMatch: 'full',
    component: SignupComponent,
  },
  {
    path: 'steps',
    loadChildren: () => import('./steps/steps.module').then((m) => m.StepsModule),
  },
];

const MAT_MODULES = [
  MatFormFieldModule,
  MatRadioModule,
  MatInputModule,
  MatAutocompleteModule,
  MatButtonModule,
  MatSelectModule,
  FormsModule,
  ReactiveFormsModule,
  MatDialogModule,
];

const ANGULAR_COMMON_MODULES = [
  SwiperModule,
  OverlayModule,
  LoaderModule,
  EscapeHtmlModule,
  ButtonLoaderModule,
  ClipboardModule,
  IkPasswordInputModule,
  ValidationCheckModule,
  PhoneInputModule,
  InternationalPhoneNumberModule,
  EscapeHtmlModule,
  AvatarModule,
  InfoBoxModule,
];

@NgModule({
  declarations: [
    SignupComponent,
    SignupLandingFooterComponent,
    SignupLandingButtonsComponent,
    WebmailPasswordComponent,
    V2Component,
    SignupConnectedComponent,
    SignupNotConnectedComponent,
    SignupRightBlockComponent,
    SignupLeftBlockComponent,
    SignupLeftBlockKsuiteComponent,
    SignupDuplicatePersonnalDialogComponent,
    SignupDuplicateOrganisationDialogComponent,
    SignupRightblockClassicComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    NgxsModule.forFeature([CartState, SignupState]),
    ...MAT_MODULES,
    ...ANGULAR_COMMON_MODULES,
    TranslocoModule,
    SignupErrorsModule,
    KsuiteBlockInfoModule,
    SharedSignupModule,
    TooltipModule,
    SignupLanguageSwitcherModule,
    InvitationB2BPartnerModule,
    InvitationB2BClientModule,
    InvitationPublicCloudCreatePasswordModule,
  ],
  exports: [SignupComponent],
  providers: [SignupService],
})
export class SignupModule {}
